import React, { useEffect } from 'react';
import animateScrollTo from 'animated-scroll-to';

const URE = ({ newPage }) => {
  useEffect(() => {
    newPage();
    animateScrollTo(0);
  }, []);

  return (
    <section className="page page-URE">
      <div className="wrapper-text-column">
        <div className="text-body-column">
          <p>
            Y al igual que coexisten reyes, políticos prominentes y artistas famosos en las filas de
            la radioafición, éstas se nutren en su mayoría de personas de todos los niveles
            sociales, de todas las edades, desde adolescentes hasta que sobrepasaron los ochenta
            años y que disfrutan con la radio. Y muchos discapacitados cuya única fuente de
            diversión es la radio.
          </p>
          <p>
            La experimentación de radioaficionados ha existido siempre. Las emisoras comerciales no
            empezaron a florecer hasta después de la Primera Guerra Mundial. Ello ocasionó una gran
            confusión en las ondas y para poner un poco de orden en el éter, las administraciones de
            las distintas naciones, de común acuerdo, asignaron unas determinadas bandas de
            frecuencias para usos específicos. De esta manera los radioaficionados obtuvieron sus
            propias bandas de frecuencia.
          </p>
          <p>
            La continua experimentación a lo largo de los años trajo, primero, los tubos o lámparas
            de vacío (válvulas de radio) y posteriormente los transistores. Los equipos de radio
            disminuyeron de tamaño a la vez que resultaron más complejos. En los inicios de la radio
            el equipo era voluminoso y pesado. A veces ocupaba una habitación entera para lograr lo
            que ahora se puede hacer con el contenido de una pequeña caja metálica del tamaño de un
            maletín. Aparecen radioaficionados en los lugares más insospechados.
          </p>
          <p>
            El Dr. Peter Pehem, 5Z4JJ, es uno de los médicos volantes en Africa. Vive en una pequeña
            aldea situada en la ladera septentrional del Monte Kilimanjaro, en Kenia. Se siente
            interesado por los satélites de radioaficionado pero no puede dedicarles mucho tiempo
            durante su trabajo. Alguien regaló a Peter un viejo radioteléfono, una lámpara de radio
            y un tramo de cable coaxial. A este material el doctor añadió algunos tubos de aspirinas
            vacíos y un cristal de cuarzo procedente de la radio de su avioneta. En medio de la
            selva africana, logró construir un transmisor casero con el que conversar con el mundo
            entero a través del satélite OSCAR, el Orbiting Satellite Carrying Amateur Radio. Peter
            demostró al mundo algo importante con su equipo de construcción doméstica: no es
            necesario poseer el último modelo de equipo comercial para pasarlo bien en el éter. Una
            verdad que los recién llegados a la radioafición descubren todos los día.
          </p>
          <p>
            Las señales de radio viajan hasta los últimos confines del mundo, de manera que es
            imprescindible cierto orden para evitar el caos en las bandas. La Unión Internacional de
            Telecomunicaciones (UIT) tiene la misión de repartir la totalidad del margen de
            frecuencias útiles entre los usuarios. Existen muchos servicios de radio que necesitan
            una porción de espectro y entre ellos se incluyen los servicios de radiodifusión sonora
            y televisiva, el servicio móvil terrestre, marítimo y aeronáutica, los servicios vía
            satélite y, por supuesto, el servicio de radioaficionado. Los representantes de las
            naciones miembros de la UIT se reúnen periódicamente, se ponen de acuerdo y deciden las
            bandas de frecuencia que se destinan a cada uno de los servicios según las posibilidades
            y las necesidades de los mismos. El proceso tiene lugar en las World Administrative
            Radio Conferences (WARC) o Conferencias Administrativas de Radio Mundiales
          </p>
        </div>
        <div className="text-body-column">
          <p>
            El artículo 1, apartado 3.34 de las Radio Regulations de la Unión Internacional de las
            Telecomunicaciones se define el Servicio de Radioaficionado como: «Un servicio de
            radiocomunicación con el propósito de desarrollar la habilidad personal, la
            intercomunicación y las investigaciones técnicas llevadas a cabo por aficionados, es
            decir, por personas debidamente autorizadas interesadas en la radiotécnica sin afán de
            lucro». En estas pocas palabras se comprende todo el fundamen.to del servicio de
            radioaficionados. Además, la Resolución no 640 de las mismas Radio Regulations reconoce
            que: «dada su amplia distribución y su demostrada capacidad, las estaciones del Servicio
            de Radioaficionado se podrán utilizar como asistencia a las necesidades perentorias de
            las comunicaciones»... «respecto a las operaciones de auxilio en las catástrofes
            nacionales».
          </p>
          <p>
            Los radioaficionados tienen sus propios satélites artificiales, por medio de los que
            pueden hablar con cualquier otro lugar del mundo. Los satélites OSCAR (Orbiting
            Satellites Carrying Amateur Radio) han estado orbitando la Tierra desde el año 1961 y
            los radioaficionados los han utilizado para comunicarse con todo el orbe en fonía,
            Morse, radioteletipo y radiopaquete.
          </p>
          <p>
            Las estaciones de radioaficionado no pueden transmitir música. Está prohibido utilizar
            un vocabulario obsceno, indecente o irreverente. No está autorizada la utilización de
            códigos o cifrados que oculten el significado de la transmisión. Esto último significa
            que no es legal la utilización de un código «secreto» para comunicarse con un amigo a
            través del éter. Ningún radioaficionado debe causar interferencia maliciosa
            (intencionada) a ninguna otra radiocomunicación. Puede ocurrir que a uno no le guste la
            práctica operativo de otro colega o que crea que aquél está operando fuera de la ley,
            pero ni aun así se tiene el derecho de interferir su comunicación.
          </p>
          <p>
            El terremoto de Méjico de 1985 destruyó todos los medios de comunicación, especialmente
            con las zonas rurales, y la radioafición fue la única vía por la que las noticias del
            desastre pudieron llegar al resto del mundo. Cientos de radioaficionados pasaron días y
            noches en vela frente a sus aparatos indagando noticias de personas y de las condiciones
            de supervivencia en las zonas más afectadas. Sólo descansaron y volvieron a sus tareas
            habituales cuando se hubieron establecido las comunicaciones regulares.
          </p>
          <p>
            En tu primer contacto, probablemente tratarás de sintonizar tu transceptor en busca de
            una estación que se halle llamando «CQ» (llama a general dirigida a todo aquel que se
            halle a la escucha y desee establecer una comunicación con la estación que lanza la
            llamada). 0 tal vez hayas quedado con un amigo en hora y frecuencia determinadas para
            ver si te oye y te ayuda a realizar tu primer comunicado (amigo que se convertirá en tu
            «padrino» para siempre, dentro de la radioafición). 0 tal vez seas más valiente de lo
            que suponemos y te atrevas a lanzar tu propia llamada CQ y de golpe... ¡Oirás tu propio
            indicativo cual si regresara del éter! ¡No hay palabras para describir la emoción que
            esto produce! Desde Dios sabe dónde, alguien estará repitiendo tu propio indicativo para
            hacerte saber que ha oído tu llamada y que desea establecer una conversación contigo.
            Comprobarás como el mundo entero está lleno de radioaficionados que desean hablar
            contigo. ¡Es emocionante y pone la carne de gallina!
          </p>
          <p>
            Pronto intercambiarás tarjetas QSL (tarjetas postales especiales) para confirmar por
            escrito los contactos efectuados con otros colegas. Sirven como prueba fehaciente de
            haber realizado un determinado contacto por radio dentro de las condiciones exigidas
            para la obtención de los diplomas que otorgan las asociaciones nacionales e
            internacionales u otras organizaciones paralelas.
          </p>
          <p>
            La expresión QSL pertenece al código Q, es una «señal Q» o abreviatura
            internacionalmente reconocida que utilizan los radioaficionados y muchos otros servicios
            de telecomunicaciones como herramienta de entendimiento universal. Existe cierta intriga
            sobre el DX (comunicados a larga distancia) que atrae a un gran número de
            radioaficionados. Hablar con colegas de otros continentes constituye una emocionante
            experiencia. ¡Aunque todo colega transcontinental no es mas que un ser como tú que gusta
            de descubrir otras gentes y lugares!
          </p>
        </div>
      </div>
    </section>
  );
};

export default URE;
